// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__jJ36u","createdSearch":"index_createdSearch__hKWp+","custom_table":"index_custom_table__IOpI8"};